export default __webpack_public_path__ + "static/media/JeffersonBernard.6807f9d4.jpeg";